import axios from 'axios';
import {getWebsiteBaseUrl} from './../../shared/utils/environment.js';

/**
 * Fetch login status from API
 */
export const fetchLoginStatus = async () => {

  const url = getWebsiteBaseUrl() + '/auth-data?session_id=' + generateSessionId();
  const response = await axios.get(url);
  console.log('Fetch auth: ' + url, response);

  if (response.status !== 200) {
    console.error('Auth API responds with non-200 status', response);
    return false;
  }

  if (response.headers["content-type"] !== "application/json") {
    console.error('Auth API responds with wrong content-type', response);
    return false;
  }

  if (response.data.length === 0) {
    console.error('Auth API responds with empty string', response);
    return false;
  }

  return response.data;

};

/**
 * Is user logged in
 */
export const isLoggedIn = () => {
  return false;
};

/**
 * Session IDs don't really do anything concrete.
 * They are only nth safe mechansim to avoid caches.
 *
 * @returns string session
 */
export const generateSessionId = () => {

  const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789---_';
  let randomString = '';
  for (let i = 0; i < 256; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz+1);
  }
  return randomString + '-' + Math.round(+new Date());

};

